import { AxiosResponse } from "axios";
import { Config } from "../config";
import apiClient from "./apiClient";

export const getAllColumnsStories = async (params: {
  page: number;
  email: string;
  // Cursor: id of the last column the client already has — the backend
  // paginates with startAfter instead of reading all skipped docs.
  startAfterId?: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<any>(
    Config.endPoint.columns,
    params
  );
  return response;
};

export const getColumnById = async (params: {
  columnId: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<any>(
    Config.endPoint.columnById,
    params
  );
  return response;
};
